module.exports = __webpack_public_path__ + "img/woozy_face.5259afdf.gif";